/**
 * H5 页面业务请求的加密凭据透传：从页面 URL 的 encrypt 参数读取凭据，
 * 自动附加到代表用户访问业务的白名单接口请求头，供后端 H5UserAccountGuard 校验。
 */
export const H5_CREDENTIAL_HEADER = 'X-H5-Encrypt'

const H5_CREDENTIAL_PATHS = [
  '/tgsys/userDecrypt',
  '/rectification/detail',
  '/internaldetail/get-dispatch-detail',
  '/media/task/detail',
  '/integration/dingtalk/taskDistribution/',
]

export function h5EncryptFromLocation(): string {
  try {
    return new URLSearchParams(window.location.search).get('encrypt') || ''
  } catch {
    return ''
  }
}

export function isH5CredentialPath(url: unknown): boolean {
  if (typeof url !== 'string' || !url) return false
  return H5_CREDENTIAL_PATHS.some(path => url.includes(path))
}

export function applyH5CredentialHeader(config: { url?: unknown; headers?: unknown } | undefined): void {
  if (!config || !isH5CredentialPath(config.url)) return
  const encrypt = h5EncryptFromLocation()
  if (!encrypt) return
  const headers = config.headers as
    | { set?: (name: string, value: string) => void; [key: string]: unknown }
    | undefined
  if (!headers) return
  if (typeof headers.set === 'function') {
    headers.set(H5_CREDENTIAL_HEADER, encrypt)
  } else if (!headers[H5_CREDENTIAL_HEADER]) {
    headers[H5_CREDENTIAL_HEADER] = encrypt
  }
}
